import * as angular from 'angular';
import * as _ from 'lodash';

import {
    TagDateValue,
    WidgetValuesReadConfiguration,
    AggregationMode,
    AggregationConfiguration,
    IPeriodConfiguration
} from '../../models';
import { IwidgetIntervalHelperService } from '../../services';
import { Helper } from '../../common';
import {
    IdataWidget,
    WidgetWithErrors,
    ISeriesConfiguration
} from '../../widgets';
import { SpotValuesWidgetConfiguration } from './spotValuesWidget.configuration';
import { spotValuesWidgetDefinition as definition } from './spotValuesWidget.definition';

export class SpotValuesWidget extends WidgetWithErrors implements IdataWidget {
    baseType = definition.baseType;
    col = 0;
    configuration: SpotValuesWidgetConfiguration;
    data: TagDateValue[];
    exportFormats = ['csv'];
    exportToCsv: () => void;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isExportable = true;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;

    private _noneAggregation: AggregationConfiguration = { period: null, mode: AggregationMode.Average };

    constructor(
        private _$q: angular.IQService,
        __intervalHelper: IwidgetIntervalHelperService
    ) {
        super(__intervalHelper);
        this.guid = Helper.getGuid();
        this.configuration = new SpotValuesWidgetConfiguration();
    }

    getSeriesGuids(): string[] {
        return [];
    }

    getReadConfiguration(beginDate: string, endDate: string): WidgetValuesReadConfiguration {
        return this.getReadConfigurationBase(beginDate, endDate, [], {} as IPeriodConfiguration, this._noneAggregation, false, false, false, false, false);
    }

    getReadConfigurationAsync(): angular.IPromise<WidgetValuesReadConfiguration> {
        const config = this.createConfiguration([], this._noneAggregation, false, false, false, false, false);
        return this._$q.when<WidgetValuesReadConfiguration>(config);
    }

    getSeries(): ISeriesConfiguration[] {
        return [];
    }

    setSeries(series: ISeriesConfiguration[]) {
        // do nothing
    }
}